<div class="col-md-12 accordion-parent">
  <cdk-accordion class="rtr-accordion">
    @for (tab of tabsList; track tab; let index = $index) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        class="rtr-accordion-item"
        role="button"
        tabindex="0"
        [attr.id]="'accordion-header-' + index"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + index">
        <div class="rtr-accordion-item-header" (click)="accordionItem.toggle()">
          <h5>{{tab}}</h5>
          <span class="rtr-accordion-item-description">
            @if (!accordionItem.expanded) {
              <i class="fa fa-caret-down"></i>
            }
            @if (accordionItem.expanded) {
              <i class="fa fa-caret-up"></i>
            }
          </span>
        </div>
        <div
          class="rtr-accordion-item-body"
          role="region"
          [style.display]="accordionItem.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + index"
          [attr.aria-labelledby]="'accordion-header-' + index">
          <!-- Application details : start -->
          @if (tab === 'Application details') {
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Applicant number</label>
                      <div
                        type="text"
                        class="form-control readonly"
                      [innerHTML]="
                        application?.personalDetails?.registration?.registrationNumber ||
                        '-'
                      "
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Applicant name</label>
                      <div
                        type="text"
                        name="reg"
                        class="form-control readonly"
                        [innerHTML]="fullName"
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Date Submitted</label>
                      <div
                        type="text"
                        class="form-control readonly"
                      [innerHTML]="
                        application?.form?.dateApplicationSubmitted
                          ? (application?.form?.dateApplicationSubmitted | utcDate)
                          : '-'
                      "
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label
                        >Is this the name you wish to be registered under if your
                        application is successful?</label
                        >
                        <div
                          type="text"
                          class="form-control readonly"
                      [innerHTML]="
                        application?.form?.returnToRegisterDetail
                          ?.confirmUserNameChange == true
                          ? 'Yes'
                          : 'No'
                      "
                        ></div>
                      </div>
                    </div>
                  </div>
                  @if (!application?.form?.returnToRegisterDetail?.confirmUserNameChange) {
                    <div
                      >
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Title</label>
                            <div
                              type="text"
                              name="reg"
                              class="form-control readonly"
                              [innerHTML]="requestedTittle || '-'"
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>First Name</label>
                            <div
                              type="text"
                              name="reg"
                              class="form-control readonly"
                              [innerHTML]="requestedFirstName || '-'"
                            ></div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Middle Name</label>
                            <div
                              type="text"
                              name="reg"
                              class="form-control readonly"
                              [innerHTML]="requestedMiddleName || '-'"
                            ></div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Last Name</label>
                            <div
                              type="text"
                              name="reg"
                              class="form-control readonly"
                              [innerHTML]="requestedLastName || '-'"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                @if (isRouteEEA) {
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12 mb-2">
                        <h2>Details of previous registration</h2>
                      </div>
                    </div>
                  </div>
                }
                @if (isRouteEEA) {
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Registration status</label>
                          <div
                            type="text"
                            name="reg"
                            class="form-control readonly"
                            [innerHTML]="registrationStatus || '-'"
                          ></div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>English language qualification</label>
                          <div
                            type="text"
                            class="form-control readonly"
                            [innerHTML]="englishCertificateOption || '-'"
                          ></div>
                        </div>
                      </div>
                      @if (englishCertificateOption == 'OET') {
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>OET candidate No.</label>
                            <div
                              type="text"
                              class="form-control readonly"
                      [innerHTML]="
                        application?.form?.returnToRegisterDetail?.oetCandidateNo || '-'
                      "
                            ></div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (application.form.attachments) {
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12 mb-2">
                        <app-application-supporting-docs
                          [application]="application"
                          [isRTR]="true"
                        ></app-application-supporting-docs>
                      </div>
                    </div>
                  </div>
                }
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 mb-2">
                      <h2>Letter of good standing</h2>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="isRegistered"
                          >Have you been registered with any other regulatory bodies in the
                          last 5 years?</label
                          >
                          <div
                            style="min-height: 40px"
                            class="form-control readonly"
                      [innerHTML]="
                        application.form?.letterOfGoodStanding?.hasRegistered == true
                          ? 'Yes'
                          : 'No'
                      "
                          ></div>
                        </div>
                      </div>
                    </div>
                    @if (application.form?.letterOfGoodStanding?.hasRegistered == true) {
                      <div
                        class="row"
                        >
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="organisationName">Organisation name</label>
                            <div
                              style="min-height: 40px"
                              class="form-control readonly"
                              [innerHTML]="application.form?.letterOfGoodStanding?.regulatoryBody"
                            ></div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="regNumber"
                              >Your registration number with this organisation</label
                              >
                              <div
                                style="min-height: 40px"
                                class="form-control readonly"
                      [innerHTML]="
                        application.form?.letterOfGoodStanding?.registrationNumber
                      "
                              ></div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="letterRequested"
                                >Have you requested a letter of good standing from this organisation
                                be sent to the GPhC?</label
                                >
                                <div
                                  style="min-height: 40px"
                                  class="form-control readonly"
                      [innerHTML]="
                        application.form?.letterOfGoodStanding?.isRequested == true
                          ? 'Yes'
                          : 'No'
                      "
                                ></div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="col-md-12">
                        <app-application-ftp
                          [application]="application"
                          [applicationType]="'rtr'"
                        ></app-application-ftp>
                      </div>
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-12 mb-2">
                            <h2>FTP questions (2)</h2>
                          </div>
                        </div>
                      </div>
                      <div class="card card-non" [class.valid]="true">
                        <label for="question" class="card-header" [innerHTML]="q8Title"></label>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="goodStanding"
                            >Have you worked as a pharmacist or pharmacy technician in Great Britain
                            while not registered with the GPhC?</label
                            >
                            <div
                              style="min-height: 40px"
                              class="form-control readonly col-md-4"
                              [innerHTML]="Q10?.isRegistered == true ? 'Yes' : 'No'"
                            ></div>
                          </div>
                        </div>
                        @if (Q10?.isRegistered == true) {
                          <div class="row col-md-12">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Has this already been investigated by the GPhC?</label><br />
                                <div
                                  style="min-height: 40px"
                                  class="form-control readonly"
                                  [innerHTML]="Q10.isInvestigated == true ? 'Yes' : 'No'"
                                ></div>
                              </div>
                            </div>
                          </div>
                          @if (Q10.isInvestigated) {
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Case reference number</label><br />
                                <div
                                  type="text"
                                  class="form-control readonly"
                                  [innerHTML]="Q10.caseReferenceNo || '-'"
                                ></div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Investigation date</label><br />
                                <div
                                  type="text"
                                  class="form-control readonly"
                                  [innerHTML]="(Q10.investigationDate | utcDate) || '-'"
                                ></div>
                              </div>
                            </div>
                          } @else {
                            <div class="col-md-12">
                              <div class="form-group">
                                <label>Your job title</label><br />
                                <div
                                  type="text"
                                  class="form-control readonly"
                                  [innerHTML]="Q10.titleUsed || '-'"
                                ></div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <label>Dates of your unregistered practice</label><br />
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Start Date</label><br />
                                <div
                                  type="text"
                                  class="form-control readonly"
                                  [innerHTML]="(Q10.titleUsedFrom | utcDate) || '-'"
                                ></div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>End Date</label><br />
                                <div
                                  type="text"
                                  class="form-control readonly"
                                  [innerHTML]="(Q10.titleUsedUntil | utcDate) || '-'"
                                ></div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <label>Address</label><br />
                              <div
                                type="text"
                                class="form-control readonly"
                                [innerHTML]="Q10Address || '-'"
                              ></div>
                            </div>
                          }
                        }
                        <div class="card card-non" [class.valid]="true">
                          <label for="question" class="card-header" [innerHTML]="q9Title"></label>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="goodStanding"
                              >Have you used the title ‘pharmacist’ or ‘pharmacy technician’ (or their
                              Welsh equivalents ‘fferyllydd’ or ‘echnegydd fferylliaeth’) while not
                              registered with the GPhC?</label
                              >
                              <div
                                style="min-height: 40px"
                                class="form-control readonly col-md-4"
                                [innerHTML]="Q11?.isRegistered == true ? 'Yes' : 'No'"
                              ></div>
                            </div>
                          </div>
                          @if (Q11?.isRegistered == true) {
                            <div class="row col-md-12">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>Has this already been investigated by the GPhC?</label><br />
                                  <div
                                    style="min-height: 40px"
                                    class="form-control readonly"
                                    [innerHTML]="Q11.isInvestigated == true ? 'Yes' : 'No'"
                                  ></div>
                                </div>
                              </div>
                            </div>
                            @if (Q11.isInvestigated) {
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>Case reference number</label><br />
                                  <div
                                    type="text"
                                    class="form-control readonly"
                                    [innerHTML]="Q11.caseReferenceNo || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>Investigation date</label><br />
                                  <div
                                    type="text"
                                    class="form-control readonly"
                                    [innerHTML]="(Q11.investigationDate | utcDate) || '-'"
                                  ></div>
                                </div>
                              </div>
                            } @else {
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label>Title you used</label><br />
                                  <div
                                    type="text"
                                    class="form-control readonly"
                                    [innerHTML]="Q11.titleUsed || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-12"><label>Dates of title use</label><br /></div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>Start Date</label><br />
                                  <div
                                    type="text"
                                    class="form-control readonly"
                                    [innerHTML]="(Q11.titleUsedFrom | utcDate) || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>End Date</label><br />
                                  <div
                                    type="text"
                                    class="form-control readonly"
                                    [innerHTML]="(Q11.titleUsedUntil | utcDate) || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <label>How or where you used it?</label><br />
                                <textarea
                                  class="form-control readonly"
                                  name="usageDescription"
                                  readonly
                                  id="usageDescription"
                                  [innerHTML]="Q11.howWhereUsedIt || '-'"
                                  >
                                </textarea>
                              </div>
                            }
                          }
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-12 mb-2">
                                <h2>Application Declaration</h2>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label for="declaration1">
                                    I am applying for registration in Part 1 or Part 2 of the register
                                    and that I intend to practise as a pharmacist or pharmacy technician
                                    in Great Britain, the Channel Islands or the Isle of Man, as set out
                                    in Article 20(3) of the Pharmacy Order 2010.
                                  </label>
                                  <div
                                    style="min-height: 40px"
                                    class="form-control readonly"
                      [innerHTML]="
                        application?.form?.appDeclaration?.isQ1Confirmed ? 'Yes' : 'No'
                      "
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label for="declaration2">
                                    Other than issues that I have declared in the fitness to practise
                                    section, I am not aware of any action that I have taken, or not
                                    taken, which would be likely to result in an allegation that my
                                    fitness to practise is impaired.
                                  </label>
                                  <div
                                    style="min-height: 40px"
                                    class="form-control readonly"
                      [innerHTML]="
                        application?.form?.appDeclaration?.isQ2Confirmed ? 'Yes' : 'No'
                      "
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label for="declaration3">
                                    The information that I have provided in this application, including
                                    my evidence portfolio, is complete, true and accurate. I understand
                                    that if I am found to have given false or misleading information in
                                    connection with my application to return to the register, this may
                                    be treated as misconduct, and could result in my removal from the
                                    register.
                                  </label>
                                  <div
                                    style="min-height: 40px"
                                    class="form-control readonly"
                      [innerHTML]="
                        application?.form?.appDeclaration?.isQ3Confirmed ? 'Yes' : 'No'
                      "
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label for="declaration4">
                                    I have read and understood the declarations
                                  </label>
                                  <div
                                    style="min-height: 40px"
                                    class="form-control readonly"
                                    [innerHTML]="true ? 'Yes' : 'No'"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <!-- Application details : end -->
                      <!-- Revalidation details : start-->
                      @if (tab === 'Revalidation details') {
                        <div class="row">
                          <div class="col-md-12 reject-btn-container">
                            <div class="holder">
                              <button class="ml-2 btn btn-primary btn-lg" (click)="askConfirmationDialog()" [disabled]="isSubmissionRejected || submissionRejectedSuccessfully || loading">
                                @if (!loading) {
                                  <span>Reject revalidation submission</span>
                                }
                                @if (loading) {
                                  <i class="fa fa-circle-o-notch fa-spin fa-fw loading"></i>
                                }
                              </button>
                              @if (isSubmissionRejected) {
                                <p>Submission rejected on {{revalidationRejectDateTime | utcDate}}</p>
                              }
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Renewal date</label>
                                  <div
                                    name="renewalDate"
                                    type="text"
                                    class="form-control readonly"
                                    [innerHTML]="(revalidationDetails?.renewalDate  | utcDate) || '-' "
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Submission deadline</label>
                                  <div
                                    type="text"
                                    name="submissionDeadline"
                                    class="form-control readonly"
                                    [innerHTML]="(revalidationDetails?.expectation?.submissionDeadline | utcDate) || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Revalidation status</label>
                                  <div
                                    type="text"
                                    name="revalidationStatus"
                                    class="form-control readonly"
                                    [innerHTML]="getRevalidationStatus(revalidationDetails?.status)"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Submission date</label>
                                  <div
                                    type="text"
                                    name="submissionDate"
                                    class="form-control readonly"
                                    [innerHTML]="(revalidationDetails?.submissionDate | utcDate) || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Submission status</label>
                                  <div
                                    type="text"
                                    name="submissionStatus"
                                    class="form-control readonly"
                                    [innerHTML]="getSubmissionStatus(revalidationDetails?.submissionStatus)"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Remediation status</label>
                                  <div
                                    type="text"
                                    name="remediationStatus"
                                    class="form-control readonly"
                                    [innerHTML]="getRemediationStatus(revalidationDetails?.remediationStatus)"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Remeditaion issued on</label>
                                  <div
                                    type="text"
                                    name="remediationIssuedOn"
                                    class="form-control readonly"
                                    [innerHTML]="(revalidationDetails?.remediationIssuedOn | utcDate) || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>NOIR/NOR status</label>
                                  <div
                                    type="text"
                                    name="status"
                                    class="form-control readonly"
                                    [innerHTML]="getNoirAndNorStatus(revalidationDetails?.noirAndNorStatus)"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>NOIR issued on</label>
                                  <div
                                    type="text"
                                    name="NOIRissuedOn"
                                    class="form-control readonly"
                                    [innerHTML]="(revalidationDetails?.noirIssuedOn | utcDate) || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>NOR issued on</label>
                                  <div
                                    type="text"
                                    name="NORissuedOn"
                                    class="form-control readonly"
                                    [innerHTML]="(revalidationDetails?.norIssuedOn | utcDate) || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Review and feedback status</label>
                                  <div
                                    type="text"
                                    name="reviewAndFeedbackStatus"
                                    class="form-control readonly"
                                    [innerHTML]="getReviewAndFeedbackStatus(revalidationDetails?.reviewAndFeedbackStatus) || '-'"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Total count</label>
                                  <div
                                    type="text"
                                    name="totalCount"
                                    class="form-control readonly"
                                    [innerHTML]="revalidationDetails?.expectation?.expectedTotalCount"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Expected CPDs</label>
                                  <div
                                    type="text"
                                    name="expectedCpds"
                                    class="form-control readonly"
                                    [innerHTML]="revalidationDetails?.expectation?.expectedCpds || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Max unplanned</label>
                                  <div
                                    type="text"
                                    name="maxUnplanned"
                                    class="form-control readonly"
                                    [innerHTML]="revalidationDetails?.expectation?.maxUnplanned || '-'"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Peer discussions</label>
                                  <div
                                    type="text"
                                    name="peerDiscussions"
                                    class="form-control readonly"
                                    [innerHTML]=" revalidationDetails?.expectation?.expectedPeerDiscussions || '-'"
                                  ></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>Reflective accounts</label>
                                  <div
                                    type="text"
                                    name="reflectiveAccounts"
                                    class="form-control readonly"
                                    [innerHTML]=" revalidationDetails?.expectation?.expectedReflectiveAccounts || '-'"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-12 mb-2">
                                <h2>Entries</h2>
                              </div>
                            </div>
                          </div>
                          @if (entries?.length > 0) {
                            <div class="col-md-12 content no-boxes mrgn-btm-50 fadein" style="padding:0">
                              <div class="col-md-12">
                                <!-- <div class="row"> -->
                                <table mat-table
                                  [dataSource]="entries" multiTemplateDataRows
                                  class="mat-elevation-z8">
                                  @for (column of columnsToDisplay; track column) {
                                    <ng-container matColumnDef="{{column}}">
                                      <th mat-header-cell *matHeaderCellDef> <b>{{getColumn(column) | caseSplit}}</b> </th>
                                      <td mat-cell *matCellDef="let item"> {{getItem(column, item[column])}} </td>
                                    </ng-container>
                                  }
                                  <ng-container matColumnDef="expand">
                                    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                                    <td mat-cell *matCellDef="let item">
                                      <button mat-icon-button aria-label="expand row" (click)="(itemViewed = itemViewed === item ? null : item); $event.stopPropagation();">
                                        @if (itemViewed === item) {
                                          <i class="fa fa-caret-up"></i>
                                        } @else {
                                          <i class="fa fa-caret-down"></i>
                                        }
                                      </button>
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="expandedDetail">
                                    <td mat-cell *matCellDef="let item" [attr.colspan]="columnsToDisplayWithExpand.length">
                                      <div class="rtr-table-item-detail"
                                        [@detailExpand]="item == itemViewed ? 'expanded' : 'collapsed'">
                                        @if (questionGroups) {
                                          <div class="rtr-table-item-description">
                                            <b><p>ENTRY DETAILS</p></b>
                                            @for (questionGroup of questionGroups; track questionGroup) {
                                              <div class="details-container">
                                                @for (question of questionGroup.questions; track question) {
                                                  <div>
                                                    <b>
                                                      <div type="text" [innerHTML]="question.title"></div>
                                                    </b>
                                                    <div [innerHTML]="question.answer || '-'"></div>
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        } @else {
                                          <div class="rtr-table-item-description">
                                            <b><p class="no-details"> No entry details found</p></b>
                                          </div>
                                        }
                                      </div>
                                    </td>
                                  </ng-container>
                                  <tr mat-header-row class="title-row" *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                                  <tr mat-row *matRowDef="let item; columns: columnsToDisplayWithExpand;"
                                    class="rtr-table-item-row"
                                    [class.rtr-table-expanded-row]="itemViewed === item"
                                    (click)="itemViewed = itemViewed === item ? null : item; setElementSelected(item, itemViewed)">
                                  </tr>
                                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="rtr-table-detail-row"></tr>
                                </table>
                              </div>
                            </div>
                          } @else {
                            <ng-template [ngTemplateOutlet]="noIdentifier"></ng-template>
                          }
                        </div>
                      }
                      <!-- Revalidation details : end -->
                    </div>
                  </cdk-accordion-item>
                }
              </cdk-accordion>
            </div>
